import React, { Fragment, useState } from "react";
import { Modal, ModalBody, ModalHeader, UncontrolledTooltip } from "reactstrap";

// redux toolkit
import { useDispatch } from "react-redux";

// sayfalar, modallar vb.
import PrimPaymentCustomersTable from "./PrimPaymentCustomersTable";
import {
  fetchPrimPaymentCustomers,
  fetchPrimPaymentCustomersByCompany,
} from "../../../slices/apps/orderSlice";

const PrimPaymentCustomersModal = ({ id, isMode }) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);

  const handleOpen = async () => {
    if (modal) return;

    try {
      if (isMode) {
        await dispatch(fetchPrimPaymentCustomersByCompany(id)).unwrap();
      } else {
        await dispatch(fetchPrimPaymentCustomers(id)).unwrap();
      }
      setModal(true);
    } catch (error) {
      setModal(false);
    }
  };

  const handleClose = () => {
    setModal(false);
  };

  return (
    <Fragment>
      <button
        id={`customer-list-top-${id}`}
        style={{
          cursor: "pointer",
          border: "none",
          background: "none",
        }}
        onClick={handleOpen}
      >
        <i className="ri-arrow-right-s-line fs-18" />
      </button>

      <UncontrolledTooltip placement="top" target={`customer-list-top-${id}`}>
        Müşteri Listesi
      </UncontrolledTooltip>

      <Modal size="lg" isOpen={modal} toggle={handleClose} centered>
        <ModalHeader className="modal-title" toggle={handleClose}>
          Müşteri Listesi
        </ModalHeader>

        <ModalBody className="p-4">
          <PrimPaymentCustomersTable />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default PrimPaymentCustomersModal;
